import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import { NekoLogo } from './Logo';
import { NekoIcon } from './Icon';
import Theme from '../common/NekoTheme';
import contentSave from '@iconify/icons-mdi/content-save';

const HeaderBase = Styled.div`
  position: relative;
  color: white;
  font-family: ${Theme.fontFamily};
  font-size: ${Theme.fontSizeText};
  display: flex;
  align-items: center;
  padding: 15px 20px;
  background-color: ${Theme.header};
  border-bottom: 5px #2981b5 solid;
  display: flex;

  .nui-header-logo-container {
    width: 55px;
    height: 55px;
    padding: 10px;
    margin-right: 20px;
    background: #3D5D8D;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .nui-header-title-container {
    flex-direction: column;
    display: flex;

    .nui-header-title {
      color: white;
      font-family: ${Theme.fontFamily};
      font-size: 23px;
      line-height: normal;
      margin: 0;
    }

    .nui-header-subtitle {
      color: white;
      font-family: ${Theme.fontFamily};
      line-height: normal;
      font-size: ${Theme.fontSizeText};
    }
  }

  .nui-header-extra-content {
    flex: 1;
    margin: 0 20px;
  }
`;

const StyledNekoHeader = props => {

  const { title = 'NekoUI', subtitle = 'By Jordy Meow', children, saving = false } = props;

  return (
    <HeaderBase>
      <div className='nui-header-logo-container'>
        <NekoLogo />
      </div>
      <div className="nui-header-title-container">
        <h1 className="nui-header-title">{title}</h1>
        <small className="nui-header-subtitle"><a target='_blank' href='https://meowapps.com' 
          style={{ color: 'white', textDecoration: 'none' }}>{subtitle}</a></small>
      </div>
      <div className="nui-header-extra-content">{children}</div>
      {saving && <NekoIcon icon={contentSave} width="36" height="36" />}
    </HeaderBase>
  );
};

const NekoHeader = (props) => {
  return (<StyledNekoHeader {...props} />);
}

NekoHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  saving: PropTypes.bool
};

NekoHeader.defaultProps = {
  title: 'NekoUI',
  subtitle: 'By Jordy Meow',
  saving: false
};

export { NekoHeader };
